import _implicitStylesheets from "./support.css";
import _implicitScopedStylesheets from "./support.scoped.css?scoped=true";
import _axImage from "ax/image";
import _wdsLabeledValue from "wds/labeledValue";
import _axIcon from "ax/icon";
import _wdsLink from "wds/link";
import _axCard from "ax/card";
import _wdsButton from "wds/button";
import _wdsModal from "wds/modal";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-7" class="support-tab__heading support-tab__publisher-name${0}"${2}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<span type-style="body-2" class="support-tab__fact-value${0}"${2}>${"t1"}</span>`;
const $fragment3 = parseFragment`<span type-style="body-2" class="support-tab__fact-value${0}"${2}>${"t1"}</span>`;
const $fragment4 = parseFragment`<p type-style="body-2" class="support-tab__description${0}" data-testid="description-block"${2}>${"t1"}</p>`;
const $fragment5 = parseFragment`<div class="support-tab__divider${0}" aria-hidden="true"${2}></div>`;
const $fragment6 = parseFragment`<div class="support-tab__additional-help${0}" data-testid="additional-help"${2}><h3 type-style="display-6" class="support-tab__heading${0}"${2}>${"t2"}</h3><p type-style="body-2" class="support-tab__description${0}" data-testid="support-description"${2}>${"t4"}</p></div>`;
const $fragment7 = parseFragment`<h3 type-style="display-7" class="support-tab__heading${0}"${2}>${"t1"}</h3>`;
const $fragment8 = parseFragment`<span type-style="body-2" class="support-tab__phone-number${0}" data-testid="phone-number"${2}>${"t1"}</span>`;
const $fragment9 = parseFragment`<span${3}>${"t1"}<wbr${3}></span>`;
const $fragment10 = parseFragment`<div class="support-tab__divider${0}" aria-hidden="true"${2}></div>`;
const $fragment11 = parseFragment`<h3 type-style="display-7" class="support-tab__heading${0}"${2}>${"t1"}</h3>`;
const $fragment12 = parseFragment`<div class="support-tab__divider${0}" aria-hidden="true"${2}></div>`;
const $fragment13 = parseFragment`<h3 type-style="display-7" class="support-tab__heading${0}"${2}>${"t1"}</h3>`;
const $fragment14 = parseFragment`<a href="javascript:;" type-style="body-2" class="terms-and-conditions-link link${0}" data-testid="t&amp;c-link"${2}>${"t1"}</a>`;
const $fragment15 = parseFragment`<a${"a0:href"} target="_blank" type-style="body-1" class="link tos-link${0}"${2}>${"t1"}</a>`;
const $fragment16 = parseFragment`<h3 type-style="body-1" data-testid="app-terms-and-conditions"${3}>${"t1"}</h3>`;
const $fragment17 = parseFragment`<p data-testid="app-terms-body"${3}>${"t1"}</p>`;
const stc0 = {
  classMap: {
    "support-tab": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "support-tab__about": true
  },
  attrs: {
    "data-testid": "about-card"
  },
  key: 1
};
const stc2 = {
  classMap: {
    "support-tab__publisher-row": true
  },
  key: 2
};
const stc3 = {
  classMap: {
    "support-tab__logo": true
  },
  key: 3
};
const stc4 = {
  classMap: {
    "support-tab__facts-row": true
  },
  key: 7
};
const stc5 = {
  "data-testid": "headquarters-fact"
};
const stc6 = {
  "data-testid": "employees-fact"
};
const stc7 = {
  classMap: {
    "support-tab__contact": true
  },
  attrs: {
    "data-testid": "contact-card"
  },
  props: {
    "border": "true",
    "padding": "none"
  },
  key: 20
};
const stc8 = {
  classMap: {
    "support-tab__card-body": true
  },
  key: 21
};
const stc9 = {
  classMap: {
    "support-tab__section": true
  },
  attrs: {
    "data-testid": "contact-section"
  },
  key: 22
};
const stc10 = {
  classMap: {
    "support-tab__contact-row": true
  },
  attrs: {
    "data-testid": "phone-row"
  },
  key: 25
};
const stc11 = {
  classMap: {
    "support-tab__contact-icon": true
  },
  props: {
    "size": "small",
    "icon": "call",
    "ariaHidden": "true"
  },
  key: 26
};
const stc12 = {
  classMap: {
    "support-tab__contact-row": true
  },
  attrs: {
    "data-testid": "website-row"
  },
  key: 29
};
const stc13 = {
  "link": true
};
const stc14 = {
  classMap: {
    "support-tab__link-icon": true
  },
  props: {
    "size": "small",
    "icon": "new_window",
    "ariaHidden": "true"
  },
  key: 32
};
const stc15 = {
  classMap: {
    "support-tab__contact-row": true
  },
  attrs: {
    "data-testid": "email-row"
  },
  key: 33
};
const stc16 = {
  classMap: {
    "support-tab__link-icon": true
  },
  props: {
    "size": "small",
    "icon": "email",
    "ariaHidden": "true"
  },
  key: 36
};
const stc17 = {
  classMap: {
    "support-tab__email": true
  },
  attrs: {
    "data-testid": "email-address"
  },
  key: 37
};
const stc18 = {
  classMap: {
    "support-tab__section": true
  },
  attrs: {
    "data-testid": "help-section"
  },
  key: 42
};
const stc19 = {
  classMap: {
    "support-tab__contact-row": true
  },
  attrs: {
    "data-testid": "knowledge-center-row"
  },
  key: 45
};
const stc20 = {
  classMap: {
    "support-tab__link-icon": true
  },
  props: {
    "size": "small",
    "icon": "new_window",
    "ariaHidden": "true"
  },
  key: 48
};
const stc21 = {
  classMap: {
    "support-tab__section": true
  },
  attrs: {
    "data-testid": "legal-section"
  },
  key: 51
};
const stc22 = {
  classMap: {
    "support-tab__contact-row": true
  },
  key: 54
};
const stc23 = {
  "name": "terms and conditions"
};
const stc24 = {
  slotAssignment: "main-content",
  key: 59
};
const stc25 = {
  slotAssignment: "footer",
  key: 67
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind, t: api_text, k: api_key, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5} = $ctx;
  return [api_element("div", stc0, [api_element("div", stc1, [$cmp.hasProviderDetails ? api_element("div", stc2, [$cmp.hasLogo ? api_element("div", stc3, [api_custom_element("ax-image", _axImage, {
    props: {
      "imgSrc": $cmp.logo,
      "alt": $cmp.logoAlt,
      "variant": "rounded"
    },
    key: 4
  })]) : null, $cmp.publisherName ? api_static_fragment($fragment1, 6, [api_static_part(1, null, api_dynamic_text($cmp.publisherName))]) : null]) : null, $cmp.hasProviderDetails ? api_element("div", stc4, [$cmp.hasHeadquarters ? api_custom_element("wds-labeled-value", _wdsLabeledValue, {
    attrs: stc5,
    props: {
      "title": $cmp.tabLabels.headquarters
    },
    key: 8
  }, [api_static_fragment($fragment2, 10, [api_static_part(1, null, api_dynamic_text($cmp.headquarters))])]) : null, $cmp.hasEmployees ? api_custom_element("wds-labeled-value", _wdsLabeledValue, {
    attrs: stc6,
    props: {
      "title": $cmp.tabLabels.employees
    },
    key: 11
  }, [api_static_fragment($fragment3, 13, [api_static_part(1, null, api_dynamic_text($cmp.employees))])]) : null]) : null, $cmp.hasProviderDetails ? $cmp.hasDescription ? api_static_fragment($fragment4, 15, [api_static_part(1, null, api_dynamic_text($cmp.description))]) : null : null, $cmp.hasSupportDescription ? $cmp.hasProviderDetails ? api_static_fragment($fragment5, 17) : null : null, $cmp.hasSupportDescription ? api_static_fragment($fragment6, 19, [api_static_part(2, null, api_dynamic_text($cmp.tabLabels.additionalHelp)), api_static_part(4, null, api_dynamic_text($cmp.supportDescription))]) : null]), api_custom_element("ax-card", _axCard, stc7, [api_element("div", stc8, [$cmp.hasContactInfo ? api_element("div", stc9, [api_static_fragment($fragment7, 24, [api_static_part(1, null, api_dynamic_text($cmp.tabLabels.contactHeading))]), $cmp.hasPhone ? api_element("div", stc10, [api_custom_element("ax-icon", _axIcon, stc11), api_static_fragment($fragment8, 28, [api_static_part(1, null, api_dynamic_text($cmp.phone))])]) : null, $cmp.hasWebsite ? api_element("div", stc12, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "name": "support website",
      "href": $cmp.websiteUrl
    },
    key: 30,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleWebsiteAnalytics))
    }
  }, [api_element("a", {
    classMap: stc13,
    attrs: {
      "href": $cmp.websiteUrl,
      "rel": "noopener noreferrer",
      "target": "_blank",
      "type-style": "body-2"
    },
    key: 31
  }, [api_custom_element("ax-icon", _axIcon, stc14), api_text(api_dynamic_text($cmp.websiteLinkLabel))])])]) : null, $cmp.hasEmail ? api_element("div", stc15, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "name": "support email",
      "href": $cmp.mailTo
    },
    key: 34
  }, [api_element("a", {
    classMap: stc13,
    attrs: {
      "href": $cmp.mailTo,
      "type-style": "body-2"
    },
    key: 35
  }, [api_custom_element("ax-icon", _axIcon, stc16), api_element("span", stc17, api_iterator($cmp.emailSegments, function (segment) {
    return api_static_fragment($fragment9, api_key(39, segment.id), [api_static_part(1, null, api_dynamic_text(segment.text))]);
  }))])])]) : null]) : null, $cmp.hasContactInfo ? api_static_fragment($fragment10, 41) : null, $cmp.hasKnowledgeBase ? api_element("div", stc18, [api_static_fragment($fragment11, 44, [api_static_part(1, null, api_dynamic_text($cmp.tabLabels.helpHeading))]), api_element("div", stc19, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "name": "knowledge center",
      "href": $cmp.supportKnowledgeBaseURL
    },
    key: 46
  }, [api_element("a", {
    classMap: stc13,
    attrs: {
      "href": $cmp.supportKnowledgeBaseURL,
      "rel": "noopener noreferrer",
      "target": "_blank",
      "type-style": "body-2",
      "data-testid": "knowledge-center-link"
    },
    key: 47
  }, [api_custom_element("ax-icon", _axIcon, stc20), api_text(api_dynamic_text($cmp.tabLabels.knowledgeCenter))])])])]) : null, $cmp.hasKnowledgeBase ? api_static_fragment($fragment12, 50) : null, api_element("div", stc21, [api_static_fragment($fragment13, 53, [api_static_part(1, null, api_dynamic_text($cmp.tabLabels.legalHeading))]), api_element("div", stc22, [api_custom_element("wds-link", _wdsLink, {
    props: stc23,
    key: 55,
    on: {
      "analytics": _m1 || ($ctx._m1 = api_bind($cmp.handleTermsAndConditionsAnalytics))
    }
  }, [api_static_fragment($fragment14, 57, [api_static_part(0, {
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.openTermsAndConditions))
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.supportLabels.termsAndConditions))])])])])])])]), $cmp.displayTermsAndConditions ? api_custom_element("wds-modal", _wdsModal, {
    props: {
      "title": $cmp.modalLabels.title,
      "closedFocusTarget": $cmp.termsAndConditionsLinkRef,
      "bodyScroll": true
    },
    key: 58,
    on: {
      "close": _m4 || ($ctx._m4 = api_bind($cmp.closeTermsAndConditions))
    }
  }, [api_element("div", stc24, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "name": "terms of service",
      "href": $cmp.modalLabels.termsOfServiceLink
    },
    key: 60
  }, [api_static_fragment($fragment15, 62, [api_static_part(0, {
    attrs: {
      "href": $cmp.modalLabels.termsOfServiceLink
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.modalLabels.termsOfServiceLinkLabel))])]), $cmp.hasTermsAndConditions ? api_static_fragment($fragment16, 64, [api_static_part(1, null, api_dynamic_text($cmp.modalLabels.appTermsAndConditions))]) : null, $cmp.hasTermsAndConditions ? api_static_fragment($fragment17, 66, [api_static_part(1, null, api_dynamic_text($cmp.termsAndConditions))]) : null]), api_element("div", stc25, [api_custom_element("wds-button", _wdsButton, {
    props: {
      "label": $cmp.modalLabels.gotIt
    },
    key: 68,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.closeTermsAndConditions))
    }
  })])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1cuikq9e96n";
tmpl.legacyStylesheetToken = "undefined-_support";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
